import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {BlacklistsState} from './types';
import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';

export const state: BlacklistsState = {
    blacklists: [],
    blacklistContacts: [],
    blacklistGenerals: [],
};


export const blacklists: Module<BlacklistsState, RootState> = {
    state,
    getters,
    actions,
    mutations
};
